import { render, staticRenderFns } from "./JobOfferComments.vue?vue&type=template&id=55ac924a&"
import script from "./JobOfferComments.vue?vue&type=script&lang=js&"
export * from "./JobOfferComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports